import { Dispatch, SetStateAction, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MutationStatus } from 'react-query';
import { fallbackEmptyString } from '../../../../../utils/StringUtils';
import { useGetSchoolCandidatePaymentAccess } from '../../../../../api-refactored/school-candidate-payment/useGetSchoolCandidatePaymentAccess';
import { PaymentMethod } from '../../PaymentButton';
import { SchoolCandidatePaymentDetailsResponse } from '../../../../../api-refactored/school-candidate-payment/usePostRetrieveSchoolCandidatePaymentDetails';
import { usePostSchoolCandidateConfirmAndPay } from '../../../../../api-refactored/school-candidate-payment/usePostSchoolCandidateConfirmAndPay';
import RouteKey from '../../../../../routes/key';
import { usePostSchoolCandidatePaymentPayNowProxyDetails } from '../../../../../api-refactored/school-candidate-payment/usePostSchoolCandidatePaymentPayNowProxyDetails';

interface UseSchoolCandidatePaymentDetailsInterface {
  setPaymentAccessDetailsOption: Dispatch<SetStateAction<PaymentMethod[]>>;
  schoolCandidatePaymentDetails: SchoolCandidatePaymentDetailsResponse;
  organisationUuid: string;
  setApiButtonStatus: Dispatch<SetStateAction<MutationStatus>>;
  setOpenPayNowProxyModal: Dispatch<SetStateAction<boolean>>;
}

const { payment } = RouteKey.child;
const { schoolCandidatePayment } = RouteKey.payment.child;
const { receipt } = schoolCandidatePayment.child;

export const useSchoolCandidatePaymentDetails = ({
  setPaymentAccessDetailsOption,
  schoolCandidatePaymentDetails,
  organisationUuid,
  setApiButtonStatus,
  setOpenPayNowProxyModal,
}: UseSchoolCandidatePaymentDetailsInterface) => {
  const { uuid } = schoolCandidatePaymentDetails;
  const history = useHistory();
  const [paymentCallback, setPaymentCallback] = useState<
    (internalTransactionRef?: string) => void
  >();
  const [paynowProxyOnCloseCallback, setPaynowProxyOnCloseCallback] = useState<
    (paymentMethod: PaymentMethod) => void
  >();
  const [paymentMethod, setPaymentMethod] = useState<string>('');

  useGetSchoolCandidatePaymentAccess({
    organisationUuid,
    enabled: !!organisationUuid,
    onSuccess: (res) => {
      const paymentAccessDetailsArray = [];
      if (res.bankTransferMethod) {
        paymentAccessDetailsArray.push(PaymentMethod.BANK_TRANSFER);
      }
      if (res.creditCardMethod) {
        paymentAccessDetailsArray.push(PaymentMethod.ENETS_CREDIT_CARD);
      }
      if (res.payNowMethod) {
        paymentAccessDetailsArray.push(PaymentMethod.PAYNOW_QR);
      }
      setPaymentAccessDetailsOption(paymentAccessDetailsArray);
    },
    onError: (_) => {
      setPaymentAccessDetailsOption([]);
    },
  });

  const { mutate: schoolCandidateConfirmAndPayMutate } = usePostSchoolCandidateConfirmAndPay({});

  const { mutate: postPayNowProxyDetails } = usePostSchoolCandidatePaymentPayNowProxyDetails({
    onSuccess: () => {
      setApiButtonStatus('success');
      setOpenPayNowProxyModal(false);
      schoolCandidateConfirmAndPayMutate(
        {
          uuid,
          paymentMode: fallbackEmptyString(paymentMethod),
        },
        {
          onSuccess: (res) => {
            if (res.paymentSuccess === true) {
              history.push(`/${payment}/${schoolCandidatePayment.route}/${uuid}/${receipt.route}`);
            }
            if (paymentCallback) {
              paymentCallback(res.internalTransactionRef);
            }
          },
          onError: () => {
            if (paymentCallback) {
              paymentCallback('');
            }
          },
        }
      );
    },
    onError: () => setApiButtonStatus('error'),
  });

  const handleClickPaymentButtonTest = (callback: () => void) => {
    callback();
  };

  const handlePaymentOption = (
    callback: (internalTransactionRef: string) => void,
    method?: string,
    onClosePaynowProxyCallback?: (paymentMethod: PaymentMethod) => void
  ) => {
    if (PaymentMethod.PAYNOW_QR === method) {
      setOpenPayNowProxyModal(true);
      setPaymentCallback(() => callback);
      setPaymentMethod(method);
      setPaynowProxyOnCloseCallback(() => onClosePaynowProxyCallback);
    } else {
      schoolCandidateConfirmAndPayMutate(
        {
          uuid,
          paymentMode: fallbackEmptyString(method),
        },
        {
          onSuccess: (res) => {
            if (res.paymentSuccess === true) {
              history.push(`/${payment}/${schoolCandidatePayment.route}/${uuid}/${receipt.route}`);
            }
            callback(res.internalTransactionRef);
          },
          onError: () => {
            callback('');
          },
        }
      );
    }
  };
  return {
    handleClickPaymentButtonTest,
    handlePaymentOption,
    postPayNowProxyDetails,
    paynowProxyOnCloseCallback,
  };
};
